import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=fd8b8a48&scoped=true&"
import script from "./CreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateInvoice.vue?vue&type=style&index=1&id=fd8b8a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8b8a48",
  null
  
)

export default component.exports